<template>
  <div>
    <div class="msg" v-if="$parent.intake.persoonsData.length > 1">
      Omdat er meerdere belanghebbende zijn binnen deze rekening vragen wij u gezamenlijk tot een
      concensus te komen over de risicobereidheid.
    </div>
    <div class="content">
      <h2 class="title">
        <awesomeIcon icon="bell"/> Risico
      </h2>

      <div class="subheader">
        Hieronder ziet u welk risico hoort bij een mogelijk rendement op jaarbasis. Goed om te weten
        is dat er ook meerdere slechtere jaren achter elkaar kunnen plaatsvinden. Welk van de
        onderstaande combinaties spreekt u het meest aan?
      </div>
      <div class="msg">
        Rendement maken kan niet zonder risico. En hoe meer rendement u nastreeft, hoe groter het
        risico wordt. Met risico bedoelen we dan hoeveel de beleggingen minder waard kunnen worden
        tijdens het beleggen. Het is daarom belangrijk dat u voor uzelf nagaat hoeveel risico u
        wilt lopen.
      </div>
      <span
        v-for="(risk, index) in find(
          risks,
          { brand:
            (
              $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
              && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                ? 'VMBS'
                : $parent.intakeAdmin.beleggen.brand
            )
          }).data
        "
        :key="index"
      >
        <customInput
          v-if="risk.show" v-model="modelValue.risk" @changed="sendUpdate"
          type="radio2" name="radiogroup1" :option="risk.name"
          :label="`€ ${formatPrice((Number(modelValue.vermogen) + Number($parent.portValue))
            * (risk.down / 100 + 1), true)},- tot € ${formatPrice(
              (Number(modelValue.vermogen) + Number($parent.portValue)
            ) * (risk.up / 100 + 1), true)},- (${risk.down}% tot ${risk.up}%)`
          "
        />
      </span>

      <template v-if="$parent.redo">
        <div class="subheader">
          Hoe heeft u de schommelingen van uw portefeuillewaarde in de afgelopen periode ervaren?
        </div>
        <customInput
          v-model="modelValue.pastPeriodExperience"
          @changed="sendUpdate"
          type="radio2"
          option="A"
          label="Ik voel me er comfortabel bij"
        />
        <customInput
          v-model="modelValue.pastPeriodExperience"
          @changed="sendUpdate"
          type="radio2"
          option="B"
          label="
            Ik maak me er zorgen over, maar begrijp dat het past binnen mijn profiel en wil zo
            doorbeleggen
          "
        />
        <customInput
          v-model="modelValue.pastPeriodExperience"
          @changed="sendUpdate"
          type="radio2"
          option="C"
          label="Ik maak me er zorgen over en ik wil mijn risicobereidheid aanpassen"
        />
        <div class="msg" v-if="modelValue.pastPeriodExperience === 'C'">
          <template
            v-if="$parent.toSatProfile(modelValue.risk) === 'DB1'
             || $parent.toSatProfile(modelValue.risk) === 'DB2'
            "
          >
            <!-- Profiel Sparen of profiel A -->
            U belegt momenteel volgens ons meest defensieve risicoprofiel. Dit kan betekenen dat
            beleggen in het algemeen niet goed (meer) bij u past. Wanneer u twijfelt, neem dan
            contact met ons op.
          </template>
          <template v-else>
            <!-- Profiel B t/m E -->
            U wilt uw risicobereidheid aanpassen naar een profiel met naar verwachting minder grote
            schommelingen, wat beter bij u past. U kunt daarvoor hierboven uw risico-rendement
            combinatie wijzigen.
          </template>
        </div>
      </template>
      <template
        v-if="$parent.intakeAdmin.beleggen.brand != 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand != 'OXBY'"
      >
        <div class="subheader">
          Risico vermijden is voor u belangrijker dan het streven naar een hoog rendement.
        </div>
        <customInput
          v-model="modelValue.risk2"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup2"
          :option="'alle'"
          :label="'Helemaal mee eens'"
        />
        <customInput
          v-model="modelValue.risk2"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup2"
          :option="'zo veel mogelijk'"
          :label="'Mee eens'"
        />
        <customInput
          v-model="modelValue.risk2"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup2"
          :option="'soms'"
          :label="'Geen mening'"
        />
        <customInput
          v-model="modelValue.risk2"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup2"
          :option="'bijna geen'"
          :label="'Mee oneens'"
        />
        <customInput
          v-model="modelValue.risk2"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup2"
          :option="'geen'"
          :label="'Helemaal mee oneens'"
        />
        <customInput
          v-if="modelValue.risk2 == 'alle' || modelValue.risk2 == 'zo veel mogelijk'"
          v-model="modelValue.confirmRisk2" style="margin-top:40px;"
          @changed="sendUpdate" type="yesno" class="small"
          :label="'U geeft de voorkeur aan een investering met weinig of geen fluctuatie en '
            + 'accepteert u de lagere rendementen die hiermee gepaard gaan.'"
        />
        <customInput
          v-if="modelValue.risk2 == 'bijna geen' || modelValue.risk2 == 'geen'"
          v-model="modelValue.confirmRisk3" style="margin-top:40px;"
          @changed="sendUpdate" type="yesno" class="small"
          :label="'Bij het streven naar een hoog rendement, accepteert u een grote kans op '
            + 'daling van het (opgebouwde) vermogen.'"
        />

        <div class="subheader">
          U maakt zich doorgaans druk over de verliezen die u heeft geleden.
        </div>
        <customInput
          v-model="modelValue.risk3"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup3"
          :option="'zeer veel'"
          :label="'Helemaal mee eens'"
        />
        <customInput
          v-model="modelValue.risk3"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup3"
          :option="'veel'"
          :label="'Mee eens'"
        />
        <customInput
          v-model="modelValue.risk3"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup3"
          :option="'een beetje'"
          :label="'Geen mening'"
        />
        <customInput
          v-model="modelValue.risk3"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup3"
          :option="'weinig'"
          :label="'Mee oneens'"
        />
        <customInput
          v-model="modelValue.risk3"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup3"
          :option="'geen'"
          :label="'Helemaal mee oneens'"
        />

        <div class="subheader" style="margin-top:20px;">
          Hoe vaak bent u van plan de waarde van uw portefeuille te raadplegen
        </div>
        <customInput
          v-model="modelValue.risk5"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup5"
          :option="'iedere dag'"
          :label="'Iedere dag'"
        />
        <customInput
          v-model="modelValue.risk5"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup5"
          :option="'iedere week'"
          :label="'Iedere week'"
        />
        <customInput
          v-model="modelValue.risk5"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup5"
          :option="'ieder kwartaal'"
          :label="'Ieder kwartaal'"
        />
        <customInput
          v-model="modelValue.risk5"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup5"
          :option="'ieder jaar'"
          :label="'Ieder jaar'"
        />
        <customInput
          v-model="modelValue.risk5"
          @changed="sendUpdate"
          type="radio2"
          name="radiogroup5"
          :option="'ten tijde van de opname'"
          :label="'Ten tijde van de opname'"
        />

        <div class="subheader" style="margin-top:20px;">
          Welke gevolgen heeft het niet halen van uw rendementsdoelstelling
           ({{modelValue.rendement}} per jaar).
        </div>
          <customInput
            v-model="modelValue.risk4"
            @changed="sendUpdate"
            type="radio2"
            name="radiogroup4"
            :option="'zeer veel'"
            :label="'Grote financiele en emotionele problemen'"
          />
          <customInput
            v-model="modelValue.risk4"
            @changed="sendUpdate"
            type="radio2"
            name="radiogroup4"
            :option="'veel'"
            :label="'Ik zou mijn levensstijl moeten aanpassen'"
          />
          <customInput
            v-model="modelValue.risk4"
            @changed="sendUpdate"
            type="radio2"
            name="radiogroup4"
            :option="'weinig'"
            :label="'Teleurstelling met nauwelijks invloed op levensstijl'"
          />
          <customInput
            v-model="modelValue.risk4"
            @changed="sendUpdate"
            type="radio2"
            name="radiogroup4"
            :option="'geen'"
            :label="'Geen financiële / emotionele gevolgen'"
          />
      </template>

      <template v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'">
        <div class="subheader">
          U kunt ons vragen om u een waarschuwingsmelding te geven. Onder welke haalbaarheidsscore
          zou u een melding willen ontvangen?
        </div>
        <div class="msg">
          Hoe hoger de haalbaarheid, hoe beter. Met een haalbaarheid van boven 50% bouwt u een
          buffer op voor mindere tijden. Terwijl met een haalbaarheid van minder dan 50% het halen
          van uw doel onzekerder wordt.
        </div>
      </template>

      <div class="subheader" v-else>
        Beleggingen kunnen tussentijds sterk dalen. Bij welke waarde van de portefeuille maakt u
        zich zorgen en wilt u contact over de beleggingen?
      </div>
      <customInput
        v-model="modelValue.warning"
        @changed="sendUpdate"
        type="slider"
        name="%"
        :label="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'
          ? 'Score '
          : 'Contactwaarde '"
        :min="0"
        :max="100"
        :step="5"
        :extra="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'
          ? parseInt(modelValue.warning) + '%'
          : '€ ' + formatPrice(
            ((Number(modelValue.vermogen) + Number($parent.portValue) || 0) / 100)
            * parseInt(modelValue.warning), true)"
        unitType="percent"
        :validation="['notrequired', 'min', 'max']"
      />
      <div class="msg" v-if="modelValue.score < modelValue.warning
        && $parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'"
      >
        U heeft uw melding ingesteld op {{formatPrice(Number(modelValue.warning), true)}}. Dit
        is boven de verwachte haalbaarheid van {{formatPrice(Number(modelValue.score))}}. Om niet
        steeds meldingen te ontvangen, kunt u beter uw melding verlagen.
      </div>

      <customInput
        style="margin-top:20px;"
        v-model="modelValue.confirmRisk"
        @changed="sendUpdate"
        type="yesno"
        :label="'Het risico bestaat dat u uw doelstelling niet behaalt. Bent u bereid dit risico '
          + 'te lopen?'"
      />
      <customInput
        v-model="modelValue.confirmRiskLoss"
        @changed="sendUpdate"
        type="yesno"
        :label="'Er is een risico dat u een deel van uw inleg verliest. Bent u bereid dit risico '
          + 'te lopen?'"
      />
      <div class="subheader">
        De looptijd van uw huidige doel is {{
          modelValue.targetDate
            ? new Date(modelValue.targetDate).getFullYear() - new Date().getFullYear()
            : modelValue.looptijd
        }} jaar.
      </div>
      <div class="msg">
        <span v-if="modelValue.lifecycleCustomer === 'No'">
          <b>Let op:</b>
          Door lifecycle uit te schakelen bouwen wij richting het eind van de looptijd het risico
          binnen de portefeuille niet af. Ik heb voldoende financiële middelen om eventuele
          tegenvallers op te vangen.
        </span>
        <span>
          Lifcycle betekent dat wij richting het eind van de looptijd het risico binnen de
          portefeuille afbouwen zodat de kans op een nog moeilijk te herstellen verlies afneemt.
        </span>
        <b @click="lifecycleModal = true" style="cursor: pointer;">
          Klik hier voor meer informatie over de lifecycle
        </b>
      </div>
      <modalWindow v-if="lifecycleModal" @close="lifecycleModal = false" width="600">
        <div class="titlebar"><awesomeIcon icon="info-circle"/> Wat is Lifecycle</div>
        <div style="width: 95%; margin: auto">
          <p style="line-height: 150%">
            Hieronder staat een overzicht van hoe risico afbouw wordt doorgevoerd. De getoonde
            profielen zijn de ‘hoogst’ geaccepteerde profielen voor de bijbehorende resterende
            looptijd.
            <br /><br />
          </p>
          <div>
            <table class="transparent-table">
              <tr>
                <td>Resterende looptijd</td>
                <td>5 jaar of meer</td>
                <td>4 jaar</td>
                <td>3 jaar</td>
                <td>2 jaar</td>
                <td>1 jaar of minder</td>
              </tr>
              <tr>
                <td>Profiel maximaal</td>
                <td>E</td>
                <td>D</td>
                <td>C</td>
                <td>B</td>
                <td>A</td>
              </tr>
            </table>
          </div>
          <p style="font-weight: 150%">
            Mocht u hierover vragen hebben, neem dan contact met ons op. <br/> <br/>
          </p>
        </div>
      </modalWindow>
      <customInput
        v-model="modelValue.lifecycleCustomer"
        type="yesno"
        label='Ik wil risico afbouwen richting het einde van de looptijd (lifecycle)'
      />
      <customInput
        v-if="modelValue.lifecycleCustomer === 'No'"
        v-model="modelValue.lifecycleCustomerOff"
        type="dropdown"
        :class="modelValue.lifecycleCustomer ? 'dropdownUp' : ''"
        :options="[
          {
            label:'Ik wil altijd met een zo hoog mogelijk risico beleggen',
            value:'Ik wil altijd met een zo hoog mogelijk risico beleggen'
          },
          {
            label:'Ik wil doorbeleggen na de looptijd van dit doel',
            value:'Ik wil doorbeleggen na de looptijd van dit doel'
          },
          {
            label:'In overleg met mijn adviseur',
            value:'In overleg met mijn adviseur'
          },
        ]"
        label='Waarom wilt u lifecycle uitschakelen?'
      />
      <template
        v-if="
          $parent.intakeAdmin.beleggen.brand != 'Doelbeleggen'
          && modelValue.confirmRiskLoss === 'Yes'
        "
      >
        <div class="subheader">
          Bij welke portefeuillewaarde, ten opzichte van
          {{$parent.redo ? 'het huidige niveau' : 'uw inleg' }}, komt u financieel in de problemen
          aan het einde van uw beleggingsperiode?
        </div>
        <customInput
          v-model="modelValue.stepout"
          @changed="sendUpdate"
          type="slider"
          name="%"
          label="Probleemwaarde "
          :extra="'€ ' +  formatPrice(
            ((Number(modelValue.vermogen) + Number($parent.portValue) || 0) / 100)
            * parseInt(modelValue.stepout), true)"
          :min="0"
          :max="100"
          :step="1"
          unitType="percent"
          :validation="['notrequired']"
        />
        <div class="msg" v-if="Number(modelValue.warning) < Number(modelValue.stepout)">
          Uw probleemwaarde is groter dan de aangegeven contactwaarde.
        </div>
      </template>
      <template v-if="
        $parent.intake.goalData.type === 'levensonderhoud'
        && $parent.intake.goalData.box === '1'
        && (modelValue.risk === 'hoog'
          || modelValue.risk === 'zeer hoog'
          || modelValue.risk === 'extreem hoog')"
      >
        <div class="subheader">
          U accepteert grote waarde schommelingen met uw pensioenvermogen.
        </div>
        <customInput
          v-model="modelValue.confirmRiskPension"
          @changed="send "
          type="yesno"
          label="
            Heeft u, indien noodzakelijk, (elders) inkomen en/of vermogen om eventuele
            bijbehorende inkomensdalingen uit deze portefeuille op te vangen?
          "
          style="min-height: 35px"
        />
      </template>

    </div>
  </div>
</template>

<script>
import { find } from 'lodash-es';

export default {
  name: 'IntakeRiskPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  data() {
    return {
      calling: false,
      refreshSat: false,
      adminToggle: false,
      risks: [
        {
          brand: 'Doelbeleggen',
          data: [
            {
              name: 'geen',
              show: true,
              up: 3.0,
              down: -0.6,
            },
            {
              name: 'zeer laag',
              show: true,
              up: 16.0,
              down: -8.0,
            },
            {
              name: 'laag',
              show: true,
              up: 20.5,
              down: -10.0,
            },
            {
              name: 'gemiddeld',
              show: true,
              up: 25.0,
              down: -12.0,
            },
            {
              name: 'hoog',
              show: true,
              up: 30.0,
              down: -14.5,
            },
            {
              name: 'zeer hoog',
              show: true,
              up: 38.0,
              down: -18.0,
            },
            {
              name: 'extreem hoog',
              show: true,
              up: 41.0,
              down: -21.0,
            },
          ],
        },
        {
          brand: 'OXBY',
          data: [
            {
              name: 'geen',
              show: true,
              up: 3.5,
              down: 0.5,
            },
            {
              name: 'zeer laag',
              show: true,
              up: 21.5,
              down: -8.5,
            },
            {
              name: 'laag',
              show: true,
              up: 24.0,
              down: -11.0,
            },
            {
              name: 'gemiddeld',
              show: true,
              up: 30.5,
              down: -14.0,
            },
            {
              name: 'hoog',
              show: true,
              up: 35.5,
              down: -17.0,
            },
            {
              name: 'zeer hoog',
              show: true,
              up: 41.0,
              down: -19.0,
            },
            {
              name: 'extreem hoog',
              show: true,
              up: 51.0,
              down: -25.0,
            },
          ],
        },
        {
          brand: 'VMBS',
          data: [
            {
              name: 'geen',
              show: true,
              up: 3.5,
              down: 0.5,
            },
            {
              name: 'zeer laag',
              show: true,
              up: 15.0,
              down: -5.0,
            },
            {
              name: 'laag',
              show: true,
              up: 21.5,
              down: -8.5,
            },
            {
              name: 'gemiddeld',
              show: true,
              up: 26.5,
              down: -12.0,
            },
            {
              name: 'hoog',
              show: true,
              up: 35.5,
              down: -17.0,
            },
            {
              name: 'zeer hoog',
              show: true,
              up: 38.0,
              down: -18.0,
            },
            {
              name: 'extreem hoog',
              show: true,
              up: 41.0,
              down: -19.0,
            },
          ],
        },
      ],
      lifecycleModal: false,
    };
  },
  computed: {
    value() {
      return this.modelValue;
    },
  },
  methods: {
    find,
    sendUpdate() {
      this.satCall();
    },
    toSatInterval(value) {
      if (value === 'Per jaar') {
        return 'Y';
      }
      if (value === 'Per halfjaar') {
        return 'H';
      }
      if (value === 'Per kwartaal') {
        return 'Q';
      }
      return 'M';
    },
    satCall() {
      clearTimeout(this.callTimer);
      this.callTimer = setTimeout(this.satCallReal, 1000);
    },
    satCallReal() {
      if (!this.calling && this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        this.calling = true;
        const call = `${this.value.vermogen}#${this.value.doel}#
          ${this.value.targetDate}${this.value.looptijd}#${this.value.stortingenBedrag}#
          ${this.$parent.intakeAdmin.beleggen.profile}#${this.$parent.intakeAdmin.beleggen.maxProfile}#
          ${this.value.stortingenInterval}#${this.value.risk}#${this.$parent.intake.goalData.lifecycleCustomer}`;
        if (this.previousCall !== call) {
          this.previousCall = call;
          this.sdk.newSat(
            Number(this.value.vermogen) + Number(this.$parent.portValue),
            this.value.doel,
            this.value.targetDate ? null : this.value.looptijd,
            this.value.targetDate,
            Number(this.value.stortingenBedrag),
            this.toSatInterval(this.value.stortingenInterval),
            this.$parent.cashflowDate,
            0,
            this.toSatInterval(0),
            null,
            this.$parent.intakeAdmin.beleggen.profile
              ? this.$parent.toSatProfile2(this.$parent.intakeAdmin.beleggen.profile)
              : null,
            this.$parent.intakeAdmin.beleggen.maxProfile
              ? this.$parent.toSatProfile2(this.$parent.intakeAdmin.beleggen.maxProfile)
              : this.$parent.toSatProfile(this.value.risk),
            (response) => {
              if (response.status === 200) {
                this.modelValue.score = response.data.score;
                if (!this.$parent.intakeAdmin.beleggen.profile) {
                  this.modelValue.optimalProfile = response.data.pvvidata ? response.data.pvvidata[0].vProfile : '?';
                }
                this.modelValue.hasToAcceptLowerScore = false;
                this.$emit('update:model-value', this.modelValue);
                this.calling = false;
                if (this.refreshSat) {
                  this.refreshSat = false;
                  this.satCall();
                }
              } else {
                window.onbeforeunload = () => {};
                this.sdk.logout();
                window.location.reload();
              }
            },
            this.$parent.intake.goalData.lifecycleCustomer !== 'No',
          );
        } else {
          this.calling = false;
        }
      } else {
        this.refreshSat = true;
      }
    },
  },
};
</script>

<style lang="scss">
.sliderinfo {
  position: absolute;
  top: 12px;
  left: 165px;
  color: $color-highlight;
}
</style>
